import { connect } from 'react-redux'
import CurrentPage from './CurrentPage'

const mapStateToProps = (state, ownProps) => ({
	page: state.currentPage[0]
})

export default connect(mapStateToProps)(CurrentPage);


// WEBPACK FOOTER //
// ./src/components/Layout/CurrentPageContainer.js